import React, { useEffect } from 'react';
import { useParams } from 'ice';
import { Servlets } from '@/service';

/**
 * 支付宝支付页面
 * @param price-订单金额
 * @param quantity-订单数量
 * @param firstChargeFlag-是否为首充 1-是 2-否
 */
function PayDeals() {
  const { price, quantity, firstChargeFlag } = useParams();

  useEffect(() => {
    // subject: 订单名称，需要前端自己生成
    Servlets('alipay', {
      subject: `系统充值短信${quantity}条`,
      price,
      quantity,
      firstChargeFlag,
    }).then((res) => {
      const divs = document.createElement('div');
      divs.innerHTML = res.data.replace('<script>document.forms[0].submit();</script>', ''); // html code
      document.body.appendChild(divs);
      document.forms.punchout_form.submit();
    });
  }, []);

  return (
    <>
    </>
  );
}

export default PayDeals;
